import { msg } from '@lingui/core/macro';

export const SHARED_CARD_ACTIONS_MARK_READ = msg`Mark read`;
export const SHARED_CARD_ACTIONS_MARK_UNREAD = msg`Mark unread`;
export const SHARED_CARD_ACTIONS_OPEN = msg`Open`;
